import React from 'react'
import ErrorBox from './ErrorBox'

export default ({ title, message }) => (
  <div className="empty-placeholder-wrapper error">
    <ErrorBox />
    <h3>{title || 'An error has occurred.'}</h3>
    <p>{message || 'Please try your search again, and contact support if the problem persists.'}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Search/SearchError.js